export default {
  address: 'Dirección *',
  'create-account-247-support': 'Asistencia 24/7',
  'create-account-secure': '100% Seguro',
  'create-account-fast': 'Retiros de dinero rápidos y sencillos',
  'create-account-gambling-commission': 'Gambling Commission',

  'create-account-promotion-amount': '##AMOUNT##',
  'create-account-promotion-type': 'Bono de Bienvenida',
  'create-account-promotion-description': 'Hasta ##UPTO_AMOUNT## en tu primer depósito',
  'create-account-promotion-spins-bonus': '+ ##SPINS_AMOUNT## Giros Gratis',

  //need translations!
  'create-account-promotion-sign-in': 'Ya tienes una cuenta?',
  'create-account-close': 'cerrar',

  'create-account-promotion-terms-row':
    '<a href="/playerprotection">18+.</a> Se <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">aplican términos.</a> Por favor, juegue responsablemente. <a href="http://www.gamblingtherapy.org/es" target="_blank">www.Gamblingtherapy.org</a>',

  'create-account-promotion-terms-latam':
    '<a href="/playerprotection">18+.</a> Se <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">aplican términos.</a> Por favor, juegue responsablemente. <a href="http://www.gamblingtherapy.org/es" target="_blank">www.Gamblingtherapy.org</a>',

  //should we have GB here? No, we shouldn't.
  // 'create-account-promotion-terms-gb': '18+. Exclusivos para jugadores nuevos. <a href="/index.php?page=promociones&scrollto=welcome_promoterms" class="ui-link">Aplican Términos</a>.',

  // "/es-ar/promotions?page=promotions&scrollto=welcome_promoterms",

  'marketing-preferences-title': 'Preferencias de comunicación',
  'marketing-preferences-description':
    'Ursa Casino ofrece a su comunidad de jugadores ofertas diarias únicas y destacadas mensuales, como bonos por depósito, giros de bonificación, giros gratis, ofertas de devolución, torneos, tablas de clasificación, premios reales, experiencias y vacaciones. Para conocerlas seleccione a continuación:',
  'marketing-preferences-post-text': 'Puede actualizar sus preferencias de comunicación en cualquier momento en la sección Mi cuenta.',
  'marketing-preferences-label-cross-brand': 'Quiero conocer las ofertas exclusivas de su red de casinos.',
  'marketing-preferences-label-brand-only': 'Solo quiero conocer las ofertas exclusivas de su casino.',
  'marketing-preferences-label-email': 'Quiero recibir ofertas por <strong>correo electrónico</strong>',
  'marketing-preferences-label-sms': 'Quiero recibir ofertas  a través de <strong>SMS</strong>',
  'marketing-preferences-label-phone-call': 'Quiero recibir ofertas por <strong>teléfono</strong>',
  'marketing-preferences-label-post': 'Quiero recibir ofertas por <strong>correo postal</strong>',

  'marketing-preferences-unified-description':
    'No te pierdas las últimas promociones y ofertas exclusivas de Ursa Casino y las marcas gestionadas por <a href="/brands" target="_blank">nuestra red</a>. Elige cómo te gustaría recibir nuestras comunicaciones.',
  'marketing-preferences-unified-label-email': 'Correo electrónico',
  'marketing-preferences-unified-label-sms': 'SMS',
  'marketing-preferences-unified-label-phone-call': 'Teléfono',
  'marketing-preferences-unified-label-phone-post': 'Correo postal',
  'deposit-custom-footer':
    "<ul><li class='safe-support'>Asistencia 24/7</li><li class='one-hundred-percent-secure'>100% Seguro</li><li class='usp-fast'>Retiros de dinero rápidos y sencillos</li></ul>",
};
